import store from '@/store'
// sale -> 销售经理 admin -> 超级管理员 finance -> 财务经理 workshop -> 车间经理
const menus = [
  {
    icon: 'home',
    title: '首页',
    path: '/',
    // hidden () {
    //   return !(store.state.user && store.state.user.authority.view.view)
    // }
  },
  // 只有超级管理员可见 处理完成
  {
    icon: 'team',
    title: '人员管理',
    path: '/User',
    hidden () {
      return !(store.state.user && store.state.user.authority.user.view)
    }
  },
  // 只有超级管理员可见 处理完成
  {
    icon: 'reconciliation',
    title: '车间管理',
    hidden () {
      return !(store.state.user && store.state.user.authority.workShop.view) && !(store.state.user && store.state.user.authority.model.view) && !(store.state.user && store.state.user.authority.proportion.view)
    },
    children: [
      {
        title: '车间列表',
        path: '/workShop',
        hidden () {
          return !(store.state.user && store.state.user.authority.workShop.view)
        }
      },
      {
        title: '车间型号',
        path: '/model',
        hidden () {
          return !(store.state.user && store.state.user.authority.model.view)
        }
      },
      {
        title: '型号含量',
        path: '/proportion',
        hidden () {
          return !(store.state.user && store.state.user.authority.proportion.view)
        }
      }
    ]
  },
  // 只有超级管理员可见 处理完成
  {
    icon: 'deployment-unit',
    title: '原材料管理',
    path: '/rawMaterial',
    hidden () {
      return !(store.state.user && store.state.user.authority.rawMaterial.view)
    }
  },
  // 只有超级管理员可见 处理完成
  {
    icon: 'block',
    title: '半成品管理',
    path: '/product/parts',
    hidden () {
      return !(store.state.user && store.state.user.authority.parts.view)
    }
  },
  // 超级管理员，车间（查看或操作），销售（查看），财务（查看）未完成
  {
    icon: 'deployment-unit',
    title: '成品管理',
    children: [
      {
        title: '成品配方',
        path: '/product/finishProduct',
        hidden () {
          return !(store.state.user && store.state.user.authority.finishProduct.view)
        }
      },
      {
        title: '成品附加费',
        path: '/product/finishSurcharge',
        hidden () {
          return !(store.state.user && store.state.user.authority.finishSurcharge.view)
        }
        // path: '/product/finishSurcharge?type=finish'
      }
    ],
    hidden () {
      return !(store.state.user && store.state.user.authority.finishProduct.view) && !(store.state.user && store.state.user.authority.finishSurcharge.view)
    }
  },
  // 超级管理员，车间（查看或操作），销售（查看），财务（查看） 未完成
  {
    icon: 'apartment',
    title: '配样管理',
    children: [
      {
        title: '未添加配方',
        path: '/product/batchingFinishProductUn',
        hidden () {
          return !(store.state.user && store.state.user.authority.batchingFinishProductUn.view)
        }
      },
      {
        title: '配样配方',
        path: '/product/batchingFinishProduct',
        hidden () {
          return !(store.state.user && store.state.user.authority.batchingFinishProduct.view)
        }
      },
      // {
      //   title: '配样附加费',
      //   path: '/product/batchingSurcharge',
      //   hidden () {
      //     return store.state.user && store.state.user.adminRole !== 'admin'
      //   }
      //   // path: '/product/finishSurcharge?type=batching'
      // }
    ],
    hidden () {
      return !(store.state.user && store.state.user.authority.batchingFinishProductUn.view) && !(store.state.user && store.state.user.authority.batchingFinishProduct.view)
    }
  },
  { // 车间经理（查看本车间，更改状态）超级管理员（查看所有）销售经理（查看本人添加，新建） 处理完成
    icon: 'file-text',
    title: '订单管理',
    hidden () {
      return !(store.state.user && store.state.user.authority.financeVerifyOrder.view) && !(store.state.user && store.state.user.authority.sentOrder.view) && !(store.state.user && store.state.user.authority.order.view) && !(store.state.user && store.state.user.authority.completeOrder.view) && !(store.state.user && store.state.user.authority.unconfirmedOrder.view) && !(store.state.user && store.state.user.authority.confirmedOrder.view) && !(store.state.user && store.state.user.authority.reserveOrder.view)
    },
    children: [
      {
        path: '/financeVerifyOrder',
        title: '待审核订单',
        hidden () {
          return !(store.state.user && store.state.user.authority.financeVerifyOrder.view)
        }
      },
      {
        path: '/order',
        title: '销售订单',
        hidden () {
          return !(store.state.user && store.state.user.authority.order.view)
        },
      },
      {
        path: '/reserveOrder',
        title: '备货订单',
        hidden () {
          return !(store.state.user && (store.state.user.authority.reserveOrder && store.state.user.authority.reserveOrder.view))
        },
      },
      {
        icon: '',
        title: '未发出订单',
        path: '/completeOrder',
        hidden () {
          return !(store.state.user && store.state.user.authority.completeOrder.view)
        }
      },
      {
        icon: '',
        title: '已发出订单',
        path: '/model/sentOrder',
        hidden () {
          return !(store.state.user && store.state.user.authority.sentOrder.view)
        }
      },
      {
        icon: '',
        title: '待一审订单',
        path: '/model/unconfirmedOrder',
        hidden () {
          return !(store.state.user && store.state.user.authority.unconfirmedOrder.view)
        }
      },
      {
        icon: '',
        title: '待二审订单',
        path: '/model/unconfirmedOrder2',
        hidden () {
          return !(store.state.user && store.state.user.authority.unconfirmedOrder2.view)
        }
      },
      // {
      //   icon: '',
      //   title: '已收货订单',
      //   path: '/deliveriesTakedOrder',
      //   hidden () {
      //     return !(store.state.user && store.state.user.authority.deliveriesTakedOrder.view)
      //   }
      // },
      {
        icon: '',
        title: '审完成订单',
        path: '/confirmedOrder',
        hidden () {
          return !(store.state.user && store.state.user.authority.confirmedOrder.view)
        }
      }
    ]
  },
  // 超级管理员，销售 处理完成
  {
    icon: 'team',
    title: '客户管理',
    hidden () {
      return !(store.state.user && store.state.user.authority.client.view) && !(store.state.user && store.state.user.authority.clientCommission.view)
    },
    children: [
      {
        icon: '',
        title: '客户列表',
        path: '/client',
        hidden () {
          return !(store.state.user && store.state.user.authority.client.view)
        }
      },
      {
        icon: '',
        title: '客户提成',
        path: '/clientCommission',
        hidden () {
          return !(store.state.user && store.state.user.authority.clientCommission.view)
        }
      },
    ]
  },
  {
    icon: 'money-collect',
    title: '工资管理',
    path: '/salary',
    hidden () {
      return !(store.state.user && store.state.user.authority.salary.view)
    }
  },
  {
    icon: 'account-book',
    title: '利润管理',
    path: '/profit',
    hidden () {
      return !(store.state.user && store.state.user.authority.profit.view)
    }
  },
  {
    icon: 'calendar',
    title: '价格日志',
    hidden () {
      return (!(store.state.user && store.state.user.authority.priceLog.view)) && (!(store.state.user && store.state.user.authority.finishProductLog.view)) && (!(store.state.user && store.state.user.authority.batchingLog.view))
    },
    children: [
      {
        icon: '',
        title: '原材料日志',
        path: '/model/priceLog',
        hidden () {
          return !(store.state.user && store.state.user.authority.priceLog.view)
        }
      },
      {
        icon: '',
        title: '成品日志',
        path: '/model/finishProductLog',
        hidden () {
          return !(store.state.user && store.state.user.authority.finishProductLog.view)
        }
      },
      {
        icon: '',
        title: '配样日志',
        path: '/model/batchingLog',
        hidden () {
          return !(store.state.user && store.state.user.authority.batchingLog.view)
        }
      },
    ]
  },
  {
    icon: 'file',
    title: '文档管理',
    path: '/model/docs',
    hidden () {
      return !(store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.view)
    }
  },
  // {
  //   icon: 'tags',
  //   title: '成品价格查询',
  //   path: '/product/priceInquiry',
  //   hidden () {
  //     return store.state.user && (store.state.user.adminRole === 'workshop' && store.state.user.adminRole === 'sale')
  //   }
  // },
  // 只有超级管理员可见 处理完成
  {
    icon: 'setting',
    title: '基本设定',
    hidden () {
      return !(store.state.user && store.state.user.authority.company.view) && !(store.state.user && store.state.user.authority.allPallet.view) && !(store.state.user && store.state.user.authority.allPack.view) && !(store.state.user && store.state.user.authority.allMark.view) && !(store.state.user && store.state.user.authority.setting.view) && !(store.state.user && store.state.user.authority && store.state.user.authority.doc && store.state.user.authority.doc.view)
    },
    children: [

      {
        title: '公司管理',
        path: '/company',
        hidden () {
          return !(store.state.user && store.state.user.authority.company.view)
        }
      },
      {
        title: '托盘管理',
        path: '/allPallet',
        hidden () {
          return !(store.state.user && store.state.user.authority.allPallet.view)
        }
      },
      {
        title: '包装管理',
        path: '/allPack',
        hidden () {
          return !(store.state.user && store.state.user.authority.allPack.view)
        }
      },
      {
        title: '麦头管理',
        path: '/allMark',
        hidden () {
          return !(store.state.user && store.state.user.authority.allMark.view)
        }
      },
      {
        title: '项目设置',
        path: '/setting',
        hidden () {
          return !(store.state.user && store.state.user.authority.setting.view)
        }
      }
    ]
  },
  // {
  //   icon: ' ',
  //   title: '测试',
  //   path: '/test'
  // }
]
export default menus
